export default [
  {
    path: '/shopping-cart/distributor',
    name: 'shopping-cart-distributor',
    meta: {
      index: 4.1
    },
    component: () =>
      import(/* webpackChunkName: "distributor" */ '@/pages/shopping-cart/distributor/index.vue')
  },
  {
    path: '/shopping-cart/success',
    name: 'shopping-cart-success',
    meta: {
      index: 4.4
    },
    component: () =>
      import(/* webpackChunkName: "success" */ '@/pages/shopping-cart/distributor/success.vue')
  },
  {
    path: '/shopping-cart/purchase',
    name: 'shopping-cart-purchase',
    meta: {
      index: 4.2,
      type: 'login'
    },
    component: () =>
      import(/* webpackChunkName: "distributor" */ '@/pages/shopping-cart/purchase/index.vue')
  },
  {
    path: '/shopping-cart/presell',
    name: 'shopping-cart-presell',
    meta: {
      index: 4.3
    },
    component: () =>
      import(/* webpackChunkName: "distributor" */ '@/pages/shopping-cart/purchase/presell-cart.vue')
  }
]
